import React from "react";
import { Button, Typography, Space } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import BreadcrumbTrail from "../shared/BreadcrumbTrail";

const { Title } = Typography;

/**
 * A reusable page layout component using Ant Design.
 *
 * @param {object} props - The component props.
 * @param {string} props.title - The title to display in the header.
 * @param {React.ReactNode} props.children - The content to render within the layout.
 * @param {Function} [props.onBack] - Optional custom back-button handler.
 * @returns {JSX.Element} The rendered layout component.
 */
const Layout = ({ title, children, onBack }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
      return;
    }

    navigate(-1);
  };

  return (
    // The main container, equivalent to MUI's Box with padding.
    // The padding value '24px' can be adjusted as needed.
    <div style={{ padding: "24px" }}>
      {/* Space component is used to align the back button and title, similar to MUI's flexbox container. */}
      <Space 
        align="center" 
        style={{ 
          marginBottom: "6px", // Equivalent to mb: 2
          marginTop: "80px" 
        }}
      >
        <Button onClick={handleBack} icon={<ArrowLeftOutlined />} />
        {/* Typography.Title for the header text. */}
        <Title 
          level={4} // level={4} is a good equivalent for MUI's h6 variant.
          style={{ 
            margin: 0, // Remove default margins from the title
            fontWeight: "bold", 
            color: "#003A6C" // Apply custom color
          }}
        >
          {title}
        </Title>
      </Space>
      <BreadcrumbTrail />
      {/* This div holds the main content of the page. */}
      <div>
        {children}
      </div>
    </div>
  );
};

export default Layout;
